import { render, staticRenderFns } from "./TixPayment.vue?vue&type=template&id=6377dd43"
import script from "./TixPayment.vue?vue&type=script&lang=ts"
export * from "./TixPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports